module.exports = __webpack_public_path__ + "static/media/Jenny-70.3-2014.d88393ac.jpg";